var version = "10.30.7";

export { version as v };
//# sourceMappingURL=package-3cf8ae82.js.map
